import { useRef, useState } from "react";

export const BeforeAfter = ({ before, after, className = "" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className={`relative aspect-[16/10] w-full overflow-hidden select-none cursor-ew-resize bg-ink ${className}`}
      onPointerDown={(e) => { dragging.current = true; update(e.clientX); }}
      onPointerMove={(e) => dragging.current && update(e.clientX)}
      onPointerUp={() => (dragging.current = false)}
      onPointerLeave={() => (dragging.current = false)}
    >
      <img src={after} alt="Dopo l'intervento" className="absolute inset-0 img-cover" loading="lazy" draggable={false} />
      <img
        src={before}
        alt="Prima dell'intervento"
        className="absolute inset-0 img-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        loading="lazy"
        draggable={false}
      />
      <div className="absolute inset-y-0 w-px bg-white/90" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-12 w-12 rounded-full border border-white/80 bg-ink/40 backdrop-blur-md flex items-center justify-center text-white text-xs tracking-widest">
          ‹ ›
        </div>
      </div>
      <span className="absolute left-5 top-5 text-[10px] uppercase tracking-[0.25em] text-white bg-ink/50 backdrop-blur px-3 py-1.5">Prima</span>
      <span className="absolute right-5 top-5 text-[10px] uppercase tracking-[0.25em] text-ink bg-white/80 backdrop-blur px-3 py-1.5">Dopo</span>
    </div>
  );
};
